import { marked } from 'marked';
import DOMPurify from 'dompurify';

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

// Legacy plain-text/Markdown body -> HTML (each line break kept)
export const legacyToHtml = (text = '') => marked.parse(text || '', { breaks: true, gfm: true });

export const articleHtml = (a) => (a?.body_html ? a.body_html : legacyToHtml(a?.body));

export const sanitize = (html) => DOMPurify.sanitize(html || '', { ADD_ATTR: ['target'] });

export const htmlToText = (html) => {
  const d = document.createElement('div');
  d.innerHTML = sanitize(html);
  return (d.innerText || d.textContent || '').replace(/\n{3,}/g, '\n\n').trim();
};
